"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patientEntities = void 0;
var patientEntities;
(function (patientEntities) {
    patientEntities["ADDRESS"] = "address";
    patientEntities["CONTACT_PERSON"] = "contactPerson";
    patientEntities["CLINICAL_DATA"] = "clinicalData";
    patientEntities["INVITE_CODE"] = "inviteCode";
    patientEntities["PCP"] = "pcp";
    patientEntities["COMMUNICATION_PREFERENCES"] = "communicationPreferences";
})(patientEntities || (exports.patientEntities = patientEntities = {}));
